export default __webpack_public_path__ + "14ed09e5f35467de9601f0b9299d2a81.png";